module.exports = __webpack_public_path__ + "img/person-agen-pilihan.25f35d32.png";